import * as React from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import styles from "../Settings.module.scss";
import { Checkbox } from "@progress/kendo-react-inputs";
import { useState } from "react";
import { GridLoader } from "components/GridLoader";

const ActiveCell = (props) => {
    return (
        <td className={`${styles[`checkbox`]}`}>
            <Checkbox
                {...props}
                className="ms-4"
                checked={props.dataItem.allowAccess}
                onChange={(e) => {
                    props.onChange({
                        dataIndex: 0,
                        dataItem: props.dataItem,
                        field: props.field,
                        syntheticEvent: e.syntheticEvent,
                        value: e.target.value,
                    });
                }}
            />
        </td>
    );
};

export const CaseMangementGrid = (props) => {
    const [data, setData] = useState(props.data);
    React.useEffect(() => {
        if (props.data.length > 1) {
            setData(props.data);
        }
    }, [props.value, props.data]);

    return (
        <div className="w-100 flex-grow-1 settings-grid users-grid" style={{ maxHeight: 'max-content' }}>
            <Grid
                data={data}
                style={{ height: "100%" }}
                sortable={true}
                loader={
                    <div style={{ height: "50px" }}>
                        <GridLoader />
                    </div>
                }
                showLoader={props.loading}
                onItemChange={(e) => {
                    props.onChange("case", e);
                }}
            >
                <GridNoRecords>
                    {props.loading ? (
                        <span></span>
                    ) : (
                        data && data.length === 0 && "No records available"
                    )}
                </GridNoRecords>
                <Column
                    field="name"
                    title="Name"
                    editable={false}
                    className="gridBoldField"
                    width="220px"
                />
                <Column field="details" title="Details" editable={false} />
                <Column
                    field="allowAccess"
                    title="Allow Access"
                    cell={ActiveCell}
                    width="140px"
                />
            </Grid>
        </div>
    );
};

export const ReportsGrid = (props) => {
    const [data, setData] = useState(props.data);

    React.useEffect(() => {
        setData(props.data);
    }, [props.value, props.data]);

    return (
        <div className="w-100 flex-grow-1 settings-grid users-grid" style={{ maxHeight: 'max-content' }}>
            <Grid
                data={data}
                style={{ height: "100%" }}
                sortable={true}
                loader={
                    <div style={{ height: "50px" }}>
                        <GridLoader />
                    </div>
                }
                showLoader={props.loading}
                onItemChange={(e) => {
                    props.onChange("report", e);
                }}
            >
                <GridNoRecords>
                    {props.loading ? (
                        <span></span>
                    ) : (
                        data && data.length === 0 && "No records available"
                    )}
                </GridNoRecords>
                <Column field="name" title="Name" className="gridBoldField" width="220px" />
                <Column field="details" title="Details" />
                <Column
                    field="allowAccess"
                    title="Allow Access"
                    cell={ActiveCell}
                    width="140px"
                />
            </Grid>
        </div>
    );
};

export const AccountsGrid = (props) => {
    const [data, setData] = useState(props.data);
    React.useEffect(() => {
        setData(props.data);
    }, [props.value, props.data]);
    return (
        <div className="w-100 flex-grow-1 settings-grid users-grid" style={{ maxHeight: 'max-content' }}>
            <Grid
                data={data}
                style={{ height: "100%" }}
                sortable={true}
                loader={
                    <div style={{ height: "50px" }}>
                        <GridLoader />
                    </div>
                }
                showLoader={props.loading}
                onItemChange={(e) => {
                    props.onChange("account", e);
                }}
            >
                <GridNoRecords>
                    {props.loading ? (
                        <span></span>
                    ) : (
                        data && data.length === 0 && "No records available"
                    )}
                </GridNoRecords>
                <Column field="name" title="Name" className="gridBoldField" width="220px" />
                <Column field="details" title="Details" />
                <Column
                    field="allowAccess"
                    title="Allow Access"
                    cell={ActiveCell}
                    width="140px"
                />
            </Grid>
        </div>
    );
};
